import { SendHelpfulRatingParams } from '../types';
import { ClientComponentLogger } from '../../../client-component-logger';

enum Endpoint {
    HELPFUL_VOTE = 'cr-helpful-vote',
    REPORT_REVIEW = 'cr-report-review',
}

export class CustomerReviewBackendRequester {
    constructor(private logger: ClientComponentLogger) {}

    public async reportReview(reviewId: string, reportReason: string): Promise<void> {
        await this.withErrorHandling(() => this.sendReportReviewRequest(reviewId, reportReason), Endpoint.REPORT_REVIEW);
    }

    public async sendHelpfulRating(helpfulRatingParams: SendHelpfulRatingParams): Promise<void> {
        await this.withErrorHandling(() => this.sendHelpfulRatingsRequest(helpfulRatingParams), Endpoint.HELPFUL_VOTE);
    }

    private async sendReportReviewRequest(reviewId: string, reportReason: string) {
        return await fetch(`/cr-report-review/${reviewId}/report`, {
            body: JSON.stringify({ reason: reportReason }),
            headers: { 'Content-Type': 'application/json' },
            method: 'POST',
        });
    }

    private async sendHelpfulRatingsRequest(helpfulRatingParams: SendHelpfulRatingParams) {
        return await fetch(`/cr-helpful-vote/${helpfulRatingParams.reviewId}/vote`, {
            body: JSON.stringify({ isPositive: helpfulRatingParams.helpful }),
            headers: { 'Content-Type': 'application/json' },
            method: 'POST',
        });
    }

    private async withErrorHandling(doRequest: () => Promise<Response>, endpoint: Endpoint): Promise<Response | void> {
        try {
            const response = await doRequest();

            if (!response.ok) {
                this.logErrorStatusNotOk(response.status, endpoint);
                return;
            }

            return response;
        } catch (error) {
            this.logError(error, endpoint);
        }
    }

    private logErrorStatusNotOk(statusCode: number, endpoint: Endpoint) {
        let message;
        switch (endpoint) {
            case Endpoint.HELPFUL_VOTE:
            case Endpoint.REPORT_REVIEW:
                message = `CustomerReviews backend returned non-ok status code ${statusCode} for /${endpoint} endpoint. Please check the logs for more details.`;
        }
        this.logger.logError({
            message,
        });
    }

    private logError(error: unknown, endpoint: Endpoint) {
        let message;
        switch (endpoint) {
            case Endpoint.HELPFUL_VOTE:
                message = 'Failed to send backend request of helpful-buttons, because an error occured';
                break;
            case Endpoint.REPORT_REVIEW:
                message = 'Failed to send backend request of reportReview, because an error occured';
                break;
        }
        this.logger.logError({
            error: error instanceof Error ? error : undefined,
            message,
        });
    }
}
